export default __webpack_public_path__ + "static/media/ban100.103d8a1e.svg";